import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service'
import { Actions, Effect, ofType } from '@ngrx/effects';
import { User, UserActionTypes, UserFailure, UserSuccess, UserEmailSuccess, UserEmailVerified } from '../actions/userActions';
import { Material, MaterialFailure, MaterialSuccess } from '../actions/userActions';

import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';

import { tap } from 'rxjs/operators';

import { UserProfileService } from '../../app/pages/user-profile/user-profile.service';
import { IndividualService } from '../../app/pages/individual/individual.service';




@Injectable()
export class UserEffects {

  constructor(
    private actions: Actions,
    private userService: UserProfileService,
    private navigate: NavigationService,
    private material : IndividualService

  ) { }
  @Effect()
  User: Observable<any> = this.actions
    .ofType(UserActionTypes.USER)
    .map((action: User) => action)
    .mergeMap(payload => {
      return this.userService.user()
        .map((data) => {
          console.log("data", data);
          if (!data.success) {
            return new UserFailure({ error: data });
          }
          console.log(data, "user_data");
          return new UserSuccess({
            success: data.success,
            successMessage: data.message,
            data: data.data
          });

        })
        .catch((error) => {
          return Observable.of(new UserFailure({ error: error }));
        });
    });

  @Effect()
  UserEmailVerified: Observable<any> = this.actions
    .ofType(UserActionTypes.USER_EMAIL_VERIFIED)
    .map((action: User) => action)
    .switchMap(payload => {
      return this.userService.email_verified().map((data) => {
        return new UserEmailSuccess({});
      })
        .catch((error) => {
          return Observable.of(new UserFailure({ error: error }));
        });
    });
  @Effect({ dispatch: false })
  UserSuccess: Observable<any> = this.actions.pipe(
    ofType(UserActionTypes.USER_SUCCESS)
  );
  @Effect({ dispatch: false })
  UserFailure: Observable<any> = this.actions.pipe(
    ofType(UserActionTypes.USER_FAILURE)
  );
  @Effect({ dispatch: false })
  UserEmailSuccess: Observable<any> = this.actions.pipe(
    ofType(UserActionTypes.EMAIL_SUCCESS)
  );

  @Effect()
  Material: Observable<any> = this.actions
    .ofType(UserActionTypes.MATERIAL_PROVIDER)
    .map((action: Material) => action.payload)
    .mergeMap(payload => {
      return this.material.materialProvider(payload)
        .map((data) => {
          console.log("data", data);
          if (!data.success) {
            return new MaterialFailure({ error: data });
          }
          console.log(data, "material data");
          return new MaterialSuccess({
            success: data.success,
            successMessage: data.message,
            data: data.data
          });

        })
        .catch((error) => {
          return Observable.of(new MaterialFailure({ error: error }));
        });
    });
}
